module.exports = {
      id: "ic-basket-normal-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-basket-normal-usage",
      toString: function () {
        return this.url;
      }
    }